import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import BootstrapVue from 'bootstrap-vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/zh-TW';

import App from './App';
import router from './router';
import store from './store';
import ApiPlugin from './api';
import AppConfig from './app.config';

Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(ElementUI, { locale });
Vue.use(ApiPlugin);

const {
  API_STANDARDS_TREE,
  APP_NAME,
  API_VERSION,
  // SECRET_KEY,
} = AppConfig;

Vue.config.productionTip = process.env.NODE_ENV === 'development';

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // axios Request
    this.axios.defaults.headers.common.Accept = `application/${API_STANDARDS_TREE}.${APP_NAME}.${API_VERSION}+json`;
    this.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
  },
}).$mount('#app');
